import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common';


export function AppInitializerFactory(translate: TranslateService, injector: Injector) {

  return () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      translate.addLangs(['pl', 'en', 'de']);
      translate.setDefaultLang('pl');
      translate.use("pl");
      let langToSet = 'pl';
      translate.use(langToSet).subscribe(() => {
      }, err => {
        resolve(null);
      }, () => {
        resolve(null);
      });
    });
  });
}
